import React, { FunctionComponent } from 'react';

const style = `
    .cls-1 {
        mix-blend-mode: multiply;
    }
`;

const WhoopsError: FunctionComponent<unknown> = () => (
    <svg width="277" height="263" xmlns="http://www.w3.org/2000/svg">
        <defs>
            <style>{style}</style>
            <linearGradient x1=".048%" y1="50.102%" x2="100.038%" y2="50.102%" id="a">
                <stop stopColor="#172B4D" stopOpacity="0" offset="8%" />
                <stop stopColor="#172B4D" offset="75%" />
            </linearGradient>
            <linearGradient x1="1968%" y1="59020%" x2="11290%" y2="59020%" id="b">
                <stop stopColor="#172B4D" stopOpacity="0" offset="8%" />
                <stop stopColor="#172B4D" offset="75%" />
            </linearGradient>
            <linearGradient x1="43753%" y1="59125%" x2="53074%" y2="59125%" id="c">
                <stop stopColor="#172B4D" stopOpacity="0" offset="8%" />
                <stop stopColor="#172B4D" offset="75%" />
            </linearGradient>
            <linearGradient x1="50%" y1="100%" x2="50%" y2="0%" id="d">
                <stop stopColor="#0052CC" offset="25%" />
                <stop stopColor="#0052CC" stopOpacity="0" offset="92%" />
            </linearGradient>
            <linearGradient x1="0%" y1="63093%" x2="10797%" y2="63093%" id="e">
                <stop stopColor="#172B4D" stopOpacity="0" offset="8%" />
                <stop stopColor="#172B4D" offset="75%" />
            </linearGradient>
            <linearGradient x1="51219%" y1="63447%" x2="62016%" y2="63447%" id="f">
                <stop stopColor="#172B4D" stopOpacity="0" offset="8%" />
                <stop stopColor="#172B4D" offset="75%" />
            </linearGradient>
            <linearGradient x1="44096%" y1="61481%" x2="49763%" y2="61481%" id="g">
                <stop stopColor="#172B4D" stopOpacity="0" offset="8%" />
                <stop stopColor="#172B4D" offset="75%" />
            </linearGradient>
            <linearGradient x1="0%" y1="50.018%" y2="50.018%" id="h">
                <stop stopColor="#FF8F73" offset="0%" />
                <stop stopColor="#FF977E" offset="27%" />
                <stop stopColor="#FFAE9A" offset="74%" />
                <stop stopColor="#FFBDAD" offset="100%" />
            </linearGradient>
            <linearGradient x1="49.985%" y1="100.039%" x2="49.985%" y2="-5.688%" id="i">
                <stop stopColor="#FFBDAD" offset="43%" />
                <stop stopColor="#FFB7A5" offset="48%" />
                <stop stopColor="#FFA18A" offset="68%" />
                <stop stopColor="#FF9479" offset="86%" />
                <stop stopColor="#FF8F73" offset="100%" />
            </linearGradient>
            <linearGradient x1="31.698%" y1="88.664%" x2="129.347%" y2="21.508%" id="j">
                <stop stopColor="#FFAB00" offset="0%" />
                <stop stopColor="#FFC02F" offset="30%" />
                <stop stopColor="#FFD35B" offset="61%" />
                <stop stopColor="#FFDF76" offset="86%" />
                <stop stopColor="#FFE380" offset="100%" />
            </linearGradient>
            <linearGradient x1="34.162%" y1="107.857%" x2="67.822%" y2="-22.411%" id="k">
                <stop stopColor="#FFAB00" offset="13%" />
                <stop stopColor="#FFAC00" stopOpacity=".99" offset="20%" />
                <stop stopColor="#FFAD00" stopOpacity=".94" offset="27%" />
                <stop stopColor="#FFB000" stopOpacity=".87" offset="34%" />
                <stop stopColor="#FFB400" stopOpacity=".76" offset="41%" />
                <stop stopColor="#FFB800" stopOpacity=".62" offset="48%" />
                <stop stopColor="#FFBE00" stopOpacity=".46" offset="54%" />
                <stop stopColor="#FFC400" stopOpacity=".3" offset="59%" />
            </linearGradient>
            <linearGradient x1="-63058%" y1="105677%" x2="-63058%" y2="71865%" id="l">
                <stop stopColor="#FFAB00" offset="13%" />
                <stop stopColor="#FFAC00" stopOpacity=".99" offset="20%" />
                <stop stopColor="#FFAD00" stopOpacity=".94" offset="27%" />
                <stop stopColor="#FFB000" stopOpacity=".87" offset="34%" />
                <stop stopColor="#FFB400" stopOpacity=".76" offset="41%" />
                <stop stopColor="#FFB800" stopOpacity=".62" offset="48%" />
                <stop stopColor="#FFBE00" stopOpacity=".46" offset="54%" />
                <stop stopColor="#FFC400" stopOpacity=".3" offset="59%" />
            </linearGradient>
            <linearGradient x1="71.838%" y1="6.117%" x2="26.839%" y2="94.203%" id="m">
                <stop stopColor="#FFBDAD" offset="0%" />
                <stop stopColor="#FFB5A3" offset="14%" />
                <stop stopColor="#FFA088" offset="37%" />
                <stop stopColor="#FF8F73" offset="52%" />
                <stop stopColor="#FF7452" offset="100%" />
            </linearGradient>
            <linearGradient x1="100%" y1="49.984%" x2="-.008%" y2="49.984%" id="n">
                <stop stopColor="#FFBDAD" offset="0%" />
                <stop stopColor="#FFB3A0" offset="6%" />
                <stop stopColor="#FF977E" offset="25%" />
                <stop stopColor="#FF8466" offset="42%" />
                <stop stopColor="#FF7857" offset="58%" />
                <stop stopColor="#FF7452" offset="72%" />
            </linearGradient>
            <linearGradient x1="49.507%" y1="100.07%" x2="49.5%" y2=".081%" id="o">
                <stop stopColor="#FFBDAD" offset="0%" />
                <stop stopColor="#FFB5A3" offset="8%" />
                <stop stopColor="#FF9F88" offset="22%" />
                <stop stopColor="#FF7C5C" offset="41%" />
                <stop stopColor="#FF7452" offset="45%" />
            </linearGradient>
            <linearGradient x1="68.392%" y1="9.662%" x2="30.802%" y2="102.126%" id="p">
                <stop stopColor="#FFBDAD" offset="12%" />
                <stop stopColor="#FFB5A3" offset="30%" />
                <stop stopColor="#FFA088" offset="59%" />
                <stop stopColor="#FF8F73" offset="78%" />
            </linearGradient>
            <linearGradient x1="70.951%" y1="6.65%" x2="27.528%" y2="93.395%" id="q">
                <stop stopColor="#FFBDAD" offset="27%" />
                <stop stopColor="#FFB5A3" offset="43%" />
                <stop stopColor="#FFA088" offset="71%" />
                <stop stopColor="#FF8F73" offset="89%" />
            </linearGradient>
            <linearGradient x1="70.054%" y1="6.35%" x2="27.257%" y2="94.011%" id="r">
                <stop stopColor="#FFBDAD" offset="14%" />
                <stop stopColor="#FFB5A3" offset="36%" />
                <stop stopColor="#FFA088" offset="75%" />
                <stop stopColor="#FF8F73" offset="100%" />
            </linearGradient>
            <linearGradient x1="11045%" y1="61181%" x2="16713%" y2="61181%" id="s">
                <stop stopColor="#172B4D" stopOpacity="0" offset="8%" />
                <stop stopColor="#172B4D" offset="75%" />
            </linearGradient>
            <linearGradient x1="0%" y1="49.746%" x2="100.031%" y2="49.746%" id="t">
                <stop stopColor="#FF991F" offset="39%" />
                <stop stopColor="#FFC400" offset="100%" />
            </linearGradient>
            <linearGradient x1="-10.425%" y1="90.434%" x2="110.467%" y2="26.836%" id="u">
                <stop stopColor="#FF991F" offset="14%" />
                <stop stopColor="#FFC400" offset="85%" />
            </linearGradient>
            <linearGradient x1="46503%" y1="61374%" x2="49763%" y2="61374%" id="v">
                <stop stopColor="#FF991F" offset="39%" />
                <stop stopColor="#FFC400" offset="100%" />
            </linearGradient>
            <linearGradient x1="46742%" y1="16870.605%" x2="49619%" y2="16074.931%" id="w">
                <stop stopColor="#FF991F" offset="14%" />
                <stop stopColor="#FFC400" offset="85%" />
            </linearGradient>
            <linearGradient x1="99.938%" y1="50.005%" x2=".062%" y2="50.005%" id="x">
                <stop stopColor="#72594B" offset="0%" />
                <stop stopColor="#8C715D" offset="56%" />
            </linearGradient>
        </defs>
        <g transform="translate(-3 -9)" fill="none" fillRule="evenodd">
            <path
                d="M208.56 219.423h-37.662a1.042 1.042 0 0 1 0-2.084h37.644a1.042 1.042 0 1 1 0 2.084h.018z"
                fill="url(#a)"
                fillRule="nonzero"
                opacity=".1"
            />
            <path
                d="M47.072 252.571H9.427a1.042 1.042 0 0 1 0-2.084h37.645a1.042 1.042 0 0 1 0 2.084z"
                fill="url(#b)"
                fillRule="nonzero"
                opacity=".1"
            />
            <path
                d="M225.15 253.019H187.52a1.042 1.042 0 1 1 0-2.084h37.632a1.042 1.042 0 1 1 0 2.084z"
                fill="url(#c)"
                fillRule="nonzero"
                opacity=".1"
            />
            <path
                d="M129.328 69.348a.938.938 0 0 1-.937-.938V.938a.938.938 0 1 1 1.875 0V68.41a.938.938 0 0 1-.938.938z"
                fill="url(#d)"
                fillRule="nonzero"
            />
            <path
                d="M213.354 216.763c0-.83-2.25-1.5-5.02-1.5-2.77 0-5.02.674-5.02 1.5v1.441c0 .831 2.25 1.5 5.02 1.5 2.77 0 5.02-.673 5.02-1.5V216.763z"
                fill="#C1C7D0"
                fillRule="nonzero"
            />
            <rect fill="#091E42" fillRule="nonzero" x="8.673" y="218.311" width="5.344" height="5.344" rx="2.672" />
            <path
                d="M21.948 195.284a1.977 1.977 0 0 1-.592.852c-.448.38-1.85 1.56-2.289 1.236-.209-.157-.106-.596 0-.81.166-.426.789-.426 1.066-.852.06-.094.098-.14.166-.234.175-.235.264-.35.328-.345.136 0 .094.353.273.426.311.128.937-.746 1.1-.648.06.047-.022.281-.052.375z"
                fill="#D4B696"
                fillRule="nonzero"
            />
            <path
                d="M17.282 196.895c.221.584 1.402.852 2.246.465a2.13 2.13 0 0 0 1.06-1.224c.197-.54 0-.673.094-1.278.205-1.279 1.279-1.99 1.049-2.238-.051-.06-.183-.098-.546 0a.264.264 0 0 0-.145-.179c-.179-.064-.426.188-.554.303a24.339 24.339 0 0 0-2.13 2.22c-.793 1.079-1.185 1.624-1.074 1.931z"
                fill="#D4B696"
                fillRule="nonzero"
            />
            <path
                d="M19.216 193.353a3.478 3.478 0 0 0-.656 1.079c-.682 1.376-1.338 2.13-1.24 2.207.098.077.303-.196.426-.324 1.074-1.04 3.09-3.332 2.766-3.63-.15-.15-.852.225-1.296.668z"
                fill="#D4B696"
                fillRule="nonzero"
            />
            <path
                d="M27.459 193.06h1.278a1.279 1.279 0 1 1 0 2.556H27.46v-2.557zM20.295 192.667h4.748v3.678h-4.748z"
                fill="#172B4D"
                fillRule="nonzero"
            />
            <path fill="#42526E" fillRule="nonzero" d="M25.047 192.667h2.139v3.678h-2.139z" />
            <path
                d="M134.149 63.47c.358.048.673-.502.78-.877.118-.41.066-.852-.145-1.223-.29-.477-.631-.38-1.168-.938-.537-.558-.622-1.07-.789-1.04-.166.03-.2.427-.149.78.094.657.507.73.712 1.42.162.554-.047.707.196 1.24.085.183.273.6.563.639z"
                fill="#A27F68"
                fillRule="nonzero"
            />
            <path
                d="M134.438 61.182s-2.13-.486-2.471-.942c-.341-.456-.354-.852-.593-.852s-.051.852-.158.972c-.106.12-.28.038-.272.298-.02.29.019.58.115.853.4.622.927 1.154 1.547 1.56.481.2 1.453.668 1.986.528.533-.14.08-2.02.08-2.02l-.234-.397z"
                fill="#A27F68"
                fillRule="nonzero"
            />
            <path
                d="M231.893 198.532l-1.615-1.117a1.41 1.41 0 0 1-.61-1.223l.128-3.043a1.41 1.41 0 0 1 .89-1.253l1.752-.695a.375.375 0 0 1 .499.35v.204h.136c.13 0 .247.08.294.2a.315.315 0 0 1-.042.312l-.294.379h.234a.46.46 0 0 1-.158.503l-.366.281-.294 1.228.115.204c.239.413.392.87.452 1.343a2.225 2.225 0 0 1-.686 1.9l-.435.427z"
                fill="#C1C7D0"
                fillRule="nonzero"
            />
            <rect fill="#8993A4" fillRule="nonzero" x="126.29" y="59.068" width="6.077" height="11.064" rx="2.24" />
            <path
                d="M126.367 60.006c.221.328.903.183 1.278 0 .425-.202.75-.568.9-1.014.178-.588-.15-.793-.09-1.645.06-.853.426-1.279.273-1.407-.154-.128-.5.15-.75.427-.47.558-.226.95-.644 1.619-.332.537-.614.477-.852 1.07-.094.226-.294.686-.115.95z"
                fill="#A27F68"
                fillRule="nonzero"
            />
            <path
                d="M134.826 63.82a1.568 1.568 0 0 1-.35-1.623 1.44 1.44 0 0 1 .623-.686l10.01 2.416a40.717 40.717 0 0 1 7.42-.06c1.24.103 2.409.26 3.5.426v1.982a7.671 7.671 0 0 0 0 1.982c-3.371.283-6.762.21-10.118-.217a237.566 237.566 0 0 1-7.944-2.984 92.431 92.431 0 0 1-3.14-1.236z"
                fill="#0049B0"
                fillRule="nonzero"
            />
            <path
                d="M128.45 58.57s-1.159-2.093-1.04-2.715c.12-.622.457-.929.26-1.104-.195-.174-.745.588-.911.58-.167-.009-.24-.205-.427 0-.253.195-.463.44-.618.72-.136.32-.332 1.867-.144 2.408.187.541.515 1.68 1.022 2.012.508.332 1.705-1.415 1.705-1.415l.154-.486z"
                fill="#A27F68"
                fillRule="nonzero"
            />
            <path
                d="M150.616 62.49c-.123.427.303.742.328 1.705a3.78 3.78 0 0 1-.328 1.607c2.587.993 4.782 1.078 5.349.188.238-.375.217-.976.187-1.705-.03-.852-.055-1.526-.426-2.02-1.023-1.483-4.777-.92-5.11.226z"
                fill="#72594B"
                fillRule="nonzero"
            />
            <path
                d="M158.215 80.096a7.22 7.22 0 0 0-.4-.89 8.2 8.2 0 0 0-.636-1.006c-.217.042-.57.11-1.023.157-.451.047-.69.047-.852.056-.925.055-2.71.132-7.671.162a9.244 9.244 0 0 0-.823 1.01 9.052 9.052 0 0 0-1.525 3.703c-1.948 10.655-2.042 14.674-2.042 14.674a1686.376 1686.376 0 0 0-.38 15.93c.065.228.189.436.359.601.511.477 1.278.367 1.896.277a4.662 4.662 0 0 0 1.616-.554 19.745 19.745 0 0 0 1.802-4.415 18.142 18.142 0 0 0 .12-8.98 37.879 37.879 0 0 1 5.02-10.173c.284 4.035.519 8.167.703 12.398.168 3.864.284 7.65.35 11.358l3.294 1.317a34.423 34.423 0 0 0 1.206-11.418 33.566 33.566 0 0 0-.426-3.46c.094-1.458.22-2.964.38-4.518.13-1.253.272-2.47.426-3.652 0 0 .524-6.103-.46-9.721-.158-.785-.708-2.255-.934-2.856z"
                fill="#0049B0"
                fillRule="nonzero"
            />
            <path
                d="M157.12 114.024c.645.005 1.29-.03 1.93-.102-.187 1.539-.426 2.779-.57 3.627a29.952 29.952 0 0 0-.589 4.94 36.59 36.59 0 0 0-.064 1.278l-1.896-.026-.392-.626-.503.741c-.94.015-1.914.015-2.92 0a54.806 54.806 0 0 1-2.902-.115l-.14-.788 2.642-.72c.527-.431.993-.931 1.385-1.488 1.035-1.47 1.278-2.962 1.462-4.147.153-.907.21-1.829.166-2.748.791.117 1.59.175 2.39.174z"
                fill="#172B4D"
                fillRule="nonzero"
            />
            <path
                d="M159.332 67.959a2.455 2.455 0 0 0-1.36-2.86 17.462 17.462 0 0 0-.72-.307c-2.327-.925-5.114-1.547-14.26-.678-2.557.243-4.548.427-5.6.542a90.527 90.527 0 0 1-6.26-4.04 66.445 66.445 0 0 1-3.495-2.596l-1.53 2.003a41.041 41.041 0 0 0 10.424 8.46c1.449.375 2.983.724 4.624 1.04 1.794.345 3.507.61 5.114.814a3.648 3.648 0 0 0-.392 1.704 4.19 4.19 0 0 0 .784 2.17c.537.903.887 2.493-.098 5.502 2.022.422 4.093.566 6.154.426a36.562 36.562 0 0 0 5.617-.916 25.494 25.494 0 0 1-.192-3.657c.041-1.517.21-3.028.503-4.518.167-.878.38-1.917.687-3.09z"
                fill="#0052CC"
                fillRule="nonzero"
            />
            <path
                d="M151.481 54.909a10.978 10.978 0 0 0-1.798 2.817c-.047.128-.06.192-.32.332-.26.141-.614.2-.545.393.068.191.451.451.494.617l-.37 2.702 1.086.427 3.674 1.432c-.047-.15-1.39-3.815-1.377-4.024.013-.208.056-.647-.192-.762-.247-.115-.63-2.25-.745-2.557a1.078 1.078 0 0 1 0-.76c.046-.37.093-.617.093-.617z"
                fill="#72594B"
                fillRule="nonzero"
            />
            <path
                d="M160.359 64.711a10.765 10.765 0 0 1-5.46.793 10.654 10.654 0 0 1-3.955-1.279c1.5-2.348 1.44-3.703 1.104-4.504-.285-.674-.771-.976-1.155-2.131-.234-.7-.52-1.556-.209-2.4.533-1.444 2.43-1.824 2.651-1.862 1.837-.341 3.661.686 4.658 1.922.674.852.797 1.543 1.402 4.637.452 2.276.802 4.04.964 4.824z"
                fill="#253858"
                fillRule="nonzero"
            />
            <path
                d="M144.901 114.024c.645.005 1.29-.03 1.93-.102-.187 1.539-.426 2.779-.57 3.627a29.952 29.952 0 0 0-.589 4.94 36.59 36.59 0 0 0-.063 1.278l-1.897-.026-.392-.626-.503.741c-.94.015-1.913.015-2.92 0a54.806 54.806 0 0 1-2.902-.115l-.14-.788 2.642-.72c.527-.431.993-.931 1.385-1.488 1.036-1.47 1.279-2.962 1.462-4.147.154-.907.21-1.829.166-2.748.792.117 1.59.175 2.391.174z"
                fill="#172B4D"
                fillRule="nonzero"
            />
            <path
                d="M145.877 134.178a.972.972 0 0 1-.93-.694l-15.252-51.858a.972.972 0 1 1 1.862-.545l15.253 51.853a.972.972 0 0 1-.929 1.244h-.004z"
                fill="#EBECF0"
                fillRule="nonzero"
            />
            <path fill="#DFE1E5" fillRule="nonzero" d="M136.07 103.306l1.599-1.45-2.63-8.932-1.598 1.445z" />
            <ellipse
                fill="#172B4D"
                fillRule="nonzero"
                opacity=".1"
                className="cls-1"
                cx="90.354"
                cy="224.912"
                rx="76.695"
                ry="16.293"
            />
            <ellipse
                fill="url(#e)"
                fillRule="nonzero"
                opacity=".1"
                className="cls-1"
                cx="23.005"
                cy="268.889"
                rx="23.005"
                ry="4.01"
            />
            <ellipse fill="url(#f)" fillRule="nonzero" opacity=".1" cx="241.294" cy="270.398" rx="23.005" ry="4.01" />
            <ellipse fill="url(#g)" fillRule="nonzero" opacity=".2" cx="200.006" cy="262.019" rx="12.078" ry="2.566" />
            <path
                fill="#FFC400"
                fillRule="nonzero"
                d="M208.926 188.563l17.218 20.465v-9.03l-17.218-19.221zM65.367 180.777h142.306v6.525H65.367z"
            />
            <path
                d="M77.322 187.306h86.301c.272-2.164.355-4.347.247-6.525H76.832a33.242 33.242 0 0 0 .49 6.525z"
                fill="#FFAB00"
                fillRule="nonzero"
            />
            <path
                d="M204.336 221.477c0-3.998-15.155-7.386-36.114-8.558-8.209-4.803-34.005-8.31-64.562-8.31-37.163 0-67.29 5.186-67.29 11.588 0 3.158 7.335 6.017 19.225 8.097a3.137 3.137 0 0 1 1.918 5.012c-.264.327-.414.73-.426 1.15 0 4.966 23.38 8.993 52.224 8.993 28.844 0 52.211-4.01 52.211-8.975v-.145c24.352-.767 42.814-4.454 42.814-8.852z"
                fill="url(#h)"
                fillRule="nonzero"
            />
            <path
                d="M167.915 212.924c-8.208-4.803-34.005-8.31-64.562-8.31-33.093 0-60.607 4.112-66.237 9.533v.179c0 3.158 7.335 6.017 19.225 8.097a3.137 3.137 0 0 1 1.918 5.012c-.264.327-.414.73-.426 1.15 0 4.966 23.38 8.993 52.224 8.993 25.264 0 46.334-3.09 51.175-7.194v-.072h.09c.55-.404.901-1.025.963-1.705v-.145c20.96-.656 37.546-3.469 41.766-7.053-.243-3.976-15.326-7.326-36.136-8.485z"
                fill="url(#i)"
                fillRule="nonzero"
            />
            <path
                d="M65.994 214.108a.729.729 0 0 1-.729-.728v-33.532a.729.729 0 0 1 1.458 0v33.532a.729.729 0 0 1-.73.728zM208.334 217.232a.729.729 0 0 1-.73-.728v-36.69a.729.729 0 1 1 1.458 0v36.685a.729.729 0 0 1-.728.733z"
                fill="#DFE1E5"
                fillRule="nonzero"
            />
            <path
                d="M102.71 131.907l91.977-93.84a3.222 3.222 0 0 1 5.494 2.693l-18.974 138.112-78.498-46.965z"
                fill="url(#j)"
                fillRule="nonzero"
            />
            <path
                fill="#FFE380"
                fillRule="nonzero"
                className="cls-1"
                d="M184.693 153.484l.367-2.659-45.2-56.814-1.369 1.398z"
            />
            <path d="M182.592 98.017l-7.56-14.136-15.862 2.344 7.56 14.14zM191.58 80.169l-7.56-14.137-15.862 2.344 7.56 14.14zM141.193 121.921l7.56 14.141 15.863-2.344-7.56-14.14zM165.929 133.522l15.862-2.344-7.56-14.14-15.863 2.343zM173.604 115.87l-7.56-14.14-15.863 2.343 7.56 14.14zM149.38 137.234l7.56 14.136 15.863-2.344-7.56-14.14zM132.205 139.77l7.56 14.14 15.863-2.343-7.56-14.141zM156.43 118.405l-7.561-14.136-15.863 2.344 7.56 14.14zM139.88 122.118l-15.862 2.343 7.56 14.141 15.863-2.348z" />
            <path
                d="M185.567 147.139l-11.451 1.704-7.56-14.17 15.862-2.344 4.12 7.71.29-2.11-3.098-5.796 3.977-.588.179-1.279-4.778.708-7.565-14.128 14.49-2.131.18-1.279-15.283 2.259-7.56-14.14 15.862-2.345 7.108 13.293.29-2.11-6.094-11.4 7.807-1.155.18-1.278-8.61 1.278-7.56-14.14 15.863-2.345 1.909 3.568.29-2.11-.887-1.654 1.134-.166.179-1.278-1.94.285-7.56-14.14 11.64-1.705.178-1.279-12.44 1.841-5.68-10.62-.917.938 5.284 9.878-15.862 2.344-.494-.924-.917.937.098.183-.324.047-1.449 1.48 2.4-.355 7.56 14.141-15.88 2.289-3.494-6.538-.916.938 3.098 5.796-10.27 1.517-1.45 1.479 12.36-1.824 7.551 14.157-15.862 2.344-6.5-12.154-.916.937 6.103 11.413-15.862 2.344-1.313-2.459-.916.938.916 1.705-3.038.447-1.45 1.479 5.115-.754 7.56 14.14-15.862 2.344-4.317-8.072-.917.938 3.921 7.33-5.14.759.184 1.236 5.583-.827 7.56 14.14-12.64 1.859.025.166 1.466.878 11.788-1.743 6.917 12.939 3.431 2.054 15.01-2.22 5.353 10.015 1.104-.588-5.144-9.62 15.862-2.343 1.773 3.315 1.104-.588-1.581-2.915 10.654-1.572.18-1.304zm-3.776-15.96l-15.862 2.343-7.56-14.14 15.862-2.345 7.56 14.141zm-17.175 2.556l-15.88 2.327-7.543-14.14 15.863-2.345 7.56 14.158zm3.542-65.342l15.862-2.344 7.56 14.141-15.862 2.344-7.56-14.14zm-8.988 17.849l15.862-2.344 7.56 14.123-15.862 2.344-7.56-14.123zm6.874 15.504l7.56 14.14-15.862 2.345-7.56-14.158 15.862-2.327zm-33.038 4.884l15.863-2.344 7.56 14.14-15.862 2.345-7.56-14.14zm-8.988 17.814l15.863-2.344 7.577 14.154-15.862 2.344-7.578-14.154zm15.769 29.467l-7.582-14.124 15.863-2.344 7.56 14.14-15.841 2.328zm17.175-2.558l-7.582-14.123 15.863-2.344 7.56 14.14-15.841 2.327z"
                fill="url(#k)"
                fillRule="nonzero"
            />
            <path
                fill="url(#l)"
                fillRule="nonzero"
                d="M183.38 49.603l9.628-1.423 4.893 9.154.29-2.11-3.87-7.236 4.965-.733.179-1.292-5.77.853-2.677-5.008-.916.938 2.28 4.266-7.556 1.116z"
            />
            <path
                d="M75.4 138.99c6.682-12.679 23.111-16.493 35.13-10.612 13.488 6.597 19.881 24.663 11.745 37.649-7.807 12.436-25.613 14.873-37.461 6.917-10.471-7.028-15.773-21.855-9.414-33.954z"
                fill="url(#m)"
                fillRule="nonzero"
            />
            <circle
                fill="url(#n)"
                fillRule="nonzero"
                transform="rotate(-62.33 167.047 186.974)"
                cx="167.047"
                cy="186.974"
                r="26.142"
            />
            <path
                d="M87.904 161.752c10.927-20.98 37.798-29.905 59.456-18.547 23.708 12.432 27.084 41.765 18.547 59.456a38.514 38.514 0 0 1-8.097 11.08 4.321 4.321 0 0 0 .852 6.888c.755.426 1.215.852 1.206 1.33-.05 2.51-13.782 4.295-21.692 4.91-20.977 1.606-43.01-1.752-43.023-4.83 0-.451.465-1.01 2.093-1.657a3.013 3.013 0 0 0 .882-5.05c-15.13-13.566-19.477-35.812-10.224-53.58z"
                fill="url(#o)"
                fillRule="nonzero"
            />
            <path
                d="M182.55 154.17c-8.451-17.83-23.304-21.206-33.042-33.02-4.573-5.54-8.775-13.89-9.75-27.037l-37.049 37.794 78.498 46.965 2.903-21.053a55.14 55.14 0 0 0-1.56-3.649z"
                fill="#FFE380"
                fillRule="nonzero"
                className="cls-1"
            />
            <path
                d="M82.88 140.021c5.3-10.454 16.748-12.619 19.787-13.211 9.525-1.803 17.14 1.756 18.777 2.787a21.79 21.79 0 0 1 3.99 3.243c2.356 2.383 22.63 22.805 17.357 32.02-2.07 3.617-5.668 1.278-23.324 6.929-7.305 2.33-9.116 3.503-13.583 3.58-1.88.03-10.556.14-17.422-5.988-7.773-6.926-10.578-19.51-5.583-29.36z"
                fill="url(#p)"
                fillRule="nonzero"
            />
            <path
                d="M136.475 158.509c4.603-9.508 14.716-12.082 16.421-12.517 10.714-2.727 22.946 1.47 29.696 10.893.589.819 10.05 14.49 2.745 27.493-7.087 12.615-22.937 12.087-23.968 12.035-11.396-.57-18.292-8.319-19.72-10.006-5.272-6.265-10.147-17.64-5.174-27.898z"
                fill="url(#q)"
                fillRule="nonzero"
            />
            <path
                d="M52.092 250.202c0-.832-2.25-1.5-5.02-1.5-2.77 0-5.02.673-5.02 1.5v1.436c0 .83 2.25 1.5 5.02 1.5 2.77 0 5.02-.673 5.02-1.5v-1.436z"
                fill="#C1C7D0"
                fillRule="nonzero"
            />
            <path
                d="M109.763 147.156c3.332-10.084 12.687-14.58 14.2-15.279 10.535-4.867 20.563-1.082 24.897.554 4.335 1.637 11.37 4.262 15.803 11.383 5.464 8.767 4.816 20.832-.92 29.321-7.991 11.823-24.808 15.181-37.504 9.12-13.242-6.302-20.738-22.199-16.476-35.1z"
                fill="url(#r)"
                fillRule="nonzero"
            />
            <path
                d="M47.101 251.19a1.04 1.04 0 0 1-1.04-1.04v-50.698a1.042 1.042 0 1 1 2.085 0v50.715a1.04 1.04 0 0 1-1.045 1.023z"
                fill="#DFE1E5"
                fillRule="nonzero"
            />
            <ellipse fill="#C1C7D0" fillRule="nonzero" cx="225.104" cy="251.629" rx="5.02" ry="1.5" />
            <ellipse fill="#C1C7D0" fillRule="nonzero" cx="225.104" cy="251.608" rx="5.02" ry="1.5" />
            <ellipse fill="#C1C7D0" fillRule="nonzero" cx="225.104" cy="251.587" rx="5.02" ry="1.5" />
            <ellipse fill="#C1C7D0" fillRule="nonzero" cx="225.104" cy="251.57" rx="5.02" ry="1.5" />
            <ellipse fill="#C1C7D0" fillRule="nonzero" cx="225.104" cy="251.548" rx="5.02" ry="1.5" />
            <ellipse fill="#C1C7D0" fillRule="nonzero" cx="225.104" cy="251.527" rx="5.02" ry="1.5" />
            <ellipse fill="#C1C7D0" fillRule="nonzero" cx="225.104" cy="251.506" rx="5.02" ry="1.5" />
            <ellipse fill="#C1C7D0" fillRule="nonzero" cx="225.104" cy="251.484" rx="5.02" ry="1.5" />
            <ellipse fill="#C1C7D0" fillRule="nonzero" cx="225.104" cy="251.463" rx="5.02" ry="1.5" />
            <ellipse fill="#C1C7D0" fillRule="nonzero" cx="225.104" cy="251.442" rx="5.02" ry="1.5" />
            <ellipse fill="#C1C7D0" fillRule="nonzero" cx="225.104" cy="251.42" rx="5.02" ry="1.5" />
            <ellipse fill="#C1C7D0" fillRule="nonzero" cx="225.104" cy="251.399" rx="5.02" ry="1.5" />
            <ellipse fill="#C1C7D0" fillRule="nonzero" cx="225.104" cy="251.382" rx="5.02" ry="1.5" />
            <ellipse fill="#C1C7D0" fillRule="nonzero" cx="225.104" cy="251.361" rx="5.02" ry="1.5" />
            <ellipse fill="#C1C7D0" fillRule="nonzero" cx="225.104" cy="251.339" rx="5.02" ry="1.5" />
            <ellipse fill="#C1C7D0" fillRule="nonzero" cx="225.104" cy="251.318" rx="5.02" ry="1.5" />
            <ellipse fill="#C1C7D0" fillRule="nonzero" cx="225.104" cy="251.297" rx="5.02" ry="1.5" />
            <ellipse fill="#C1C7D0" fillRule="nonzero" cx="225.104" cy="251.275" rx="5.02" ry="1.5" />
            <ellipse fill="#C1C7D0" fillRule="nonzero" cx="225.104" cy="251.254" rx="5.02" ry="1.5" />
            <ellipse fill="#C1C7D0" fillRule="nonzero" cx="225.104" cy="251.233" rx="5.02" ry="1.5" />
            <ellipse fill="#C1C7D0" fillRule="nonzero" cx="225.104" cy="251.212" rx="5.02" ry="1.5" />
            <ellipse fill="#C1C7D0" fillRule="nonzero" cx="225.104" cy="251.195" rx="5.02" ry="1.5" />
            <ellipse fill="#C1C7D0" fillRule="nonzero" cx="225.104" cy="251.173" rx="5.02" ry="1.5" />
            <ellipse fill="#C1C7D0" fillRule="nonzero" cx="225.104" cy="251.152" rx="5.02" ry="1.5" />
            <ellipse fill="#C1C7D0" fillRule="nonzero" cx="225.104" cy="251.131" rx="5.02" ry="1.5" />
            <ellipse fill="#C1C7D0" fillRule="nonzero" cx="225.104" cy="251.109" rx="5.02" ry="1.5" />
            <ellipse fill="#C1C7D0" fillRule="nonzero" cx="225.104" cy="251.088" rx="5.02" ry="1.5" />
            <ellipse fill="#C1C7D0" fillRule="nonzero" cx="225.104" cy="251.067" rx="5.02" ry="1.5" />
            <ellipse fill="#C1C7D0" fillRule="nonzero" cx="225.104" cy="251.045" rx="5.02" ry="1.5" />
            <ellipse fill="#C1C7D0" fillRule="nonzero" cx="225.104" cy="251.024" rx="5.02" ry="1.5" />
            <ellipse fill="#C1C7D0" fillRule="nonzero" cx="225.104" cy="251.007" rx="5.02" ry="1.5" />
            <ellipse fill="#C1C7D0" fillRule="nonzero" cx="225.104" cy="250.986" rx="5.02" ry="1.5" />
            <ellipse fill="#C1C7D0" fillRule="nonzero" cx="225.104" cy="250.964" rx="5.02" ry="1.5" />
            <ellipse fill="#C1C7D0" fillRule="nonzero" cx="225.104" cy="250.943" rx="5.02" ry="1.5" />
            <ellipse fill="#C1C7D0" fillRule="nonzero" cx="225.104" cy="250.922" rx="5.02" ry="1.5" />
            <ellipse fill="#C1C7D0" fillRule="nonzero" cx="225.104" cy="250.9" rx="5.02" ry="1.5" />
            <ellipse fill="#C1C7D0" fillRule="nonzero" cx="225.104" cy="250.879" rx="5.02" ry="1.5" />
            <ellipse fill="#C1C7D0" fillRule="nonzero" cx="225.104" cy="250.858" rx="5.02" ry="1.5" />
            <ellipse fill="#C1C7D0" fillRule="nonzero" cx="225.104" cy="250.837" rx="5.02" ry="1.5" />
            <ellipse fill="#C1C7D0" fillRule="nonzero" cx="225.104" cy="250.819" rx="5.02" ry="1.5" />
            <ellipse fill="#C1C7D0" fillRule="nonzero" cx="225.104" cy="250.798" rx="5.02" ry="1.5" />
            <ellipse fill="#C1C7D0" fillRule="nonzero" cx="225.104" cy="250.777" rx="5.02" ry="1.5" />
            <ellipse fill="#C1C7D0" fillRule="nonzero" cx="225.104" cy="250.756" rx="5.02" ry="1.5" />
            <ellipse fill="#C1C7D0" fillRule="nonzero" cx="225.104" cy="250.734" rx="5.02" ry="1.5" />
            <ellipse fill="#C1C7D0" fillRule="nonzero" cx="225.104" cy="250.713" rx="5.02" ry="1.5" />
            <ellipse fill="#C1C7D0" fillRule="nonzero" cx="225.104" cy="250.692" rx="5.02" ry="1.5" />
            <ellipse fill="#C1C7D0" fillRule="nonzero" cx="225.104" cy="250.67" rx="5.02" ry="1.5" />
            <ellipse fill="#C1C7D0" fillRule="nonzero" cx="225.104" cy="250.653" rx="5.02" ry="1.5" />
            <ellipse fill="#C1C7D0" fillRule="nonzero" cx="225.104" cy="250.632" rx="5.02" ry="1.5" />
            <ellipse fill="#C1C7D0" fillRule="nonzero" cx="225.104" cy="250.611" rx="5.02" ry="1.5" />
            <ellipse fill="#C1C7D0" fillRule="nonzero" cx="225.104" cy="250.589" rx="5.02" ry="1.5" />
            <ellipse fill="#C1C7D0" fillRule="nonzero" cx="225.104" cy="250.568" rx="5.02" ry="1.5" />
            <ellipse fill="#C1C7D0" fillRule="nonzero" cx="225.104" cy="250.547" rx="5.02" ry="1.5" />
            <ellipse fill="#C1C7D0" fillRule="nonzero" cx="225.104" cy="250.525" rx="5.02" ry="1.5" />
            <ellipse fill="#C1C7D0" fillRule="nonzero" cx="225.104" cy="250.504" rx="5.02" ry="1.5" />
            <ellipse fill="#C1C7D0" fillRule="nonzero" cx="225.104" cy="250.483" rx="5.02" ry="1.5" />
            <ellipse fill="#C1C7D0" fillRule="nonzero" cx="225.104" cy="250.466" rx="5.02" ry="1.5" />
            <ellipse fill="#C1C7D0" fillRule="nonzero" cx="225.104" cy="250.444" rx="5.02" ry="1.5" />
            <ellipse fill="#C1C7D0" fillRule="nonzero" cx="225.104" cy="250.423" rx="5.02" ry="1.5" />
            <ellipse fill="#C1C7D0" fillRule="nonzero" cx="225.104" cy="250.402" rx="5.02" ry="1.5" />
            <ellipse fill="#C1C7D0" fillRule="nonzero" cx="225.104" cy="250.381" rx="5.02" ry="1.5" />
            <ellipse fill="#C1C7D0" fillRule="nonzero" cx="225.104" cy="250.359" rx="5.02" ry="1.5" />
            <ellipse fill="#C1C7D0" fillRule="nonzero" cx="225.104" cy="250.338" rx="5.02" ry="1.5" />
            <ellipse fill="#C1C7D0" fillRule="nonzero" cx="225.104" cy="250.317" rx="5.02" ry="1.5" />
            <ellipse fill="#C1C7D0" fillRule="nonzero" cx="225.104" cy="250.295" rx="5.02" ry="1.5" />
            <ellipse fill="#C1C7D0" fillRule="nonzero" cx="225.104" cy="250.278" rx="5.02" ry="1.5" />
            <ellipse fill="#C1C7D0" fillRule="nonzero" cx="225.104" cy="250.257" rx="5.02" ry="1.5" />
            <ellipse fill="#C1C7D0" fillRule="nonzero" cx="225.104" cy="250.236" rx="5.02" ry="1.5" />
            <ellipse fill="#C1C7D0" fillRule="nonzero" cx="225.104" cy="250.214" rx="5.02" ry="1.5" />
            <ellipse fill="#C1C7D0" fillRule="nonzero" cx="225.104" cy="250.193" rx="5.02" ry="1.5" />
            <path
                d="M225.104 250.764a1.04 1.04 0 0 1-1.04-1.04v-50.698a1.042 1.042 0 1 1 2.084 0v50.715a1.04 1.04 0 0 1-1.044 1.023z"
                fill="#DFE1E5"
                fillRule="nonzero"
            />
            <path fill="#FFC400" fillRule="nonzero" d="M65.274 188.563l-17.12 20.116v-8.332l17.12-19.57z" />
            <path fill="#FFE380" fillRule="nonzero" d="M46.057 200.347h180.086v8.332H46.057z" />
            <path
                fill="#FFF0B2"
                fillRule="nonzero"
                d="M50.379 208.679h7.897l5.706-8.332H56.09zM80.096 200.347h-7.893l-5.71 8.332h7.897zM96.21 200.347h-7.893l-5.71 8.332h7.897zM112.324 200.347h-7.893l-5.71 8.332h7.896zM128.438 200.347h-7.893l-5.71 8.332h7.896zM144.552 200.347h-7.898l-5.706 8.332h7.897zM160.665 200.347h-7.897l-5.706 8.332h7.897zM176.78 200.347h-7.898l-5.706 8.332h7.892zM192.893 200.347h-7.897l-5.707 8.332h7.893zM209.007 200.347h-7.897l-5.707 8.332h7.893zM225.12 200.347h-7.896l-5.707 8.332h7.893z"
            />
            <ellipse
                fill="url(#s)"
                fillRule="nonzero"
                opacity=".2"
                className="cls-1"
                cx="59.149"
                cy="260.741"
                rx="12.078"
                ry="2.566"
            />
            <path
                d="M71.223 258.955c0-.993-3.111-1.798-6.947-1.798-3.835 0-6.946.805-6.946 1.798v1.44c0 .994 3.11 1.8 6.946 1.8s6.947-.806 6.947-1.8v-1.44z"
                fill="url(#t)"
                fillRule="nonzero"
            />
            <path
                d="M69.548 258.572a16.715 16.715 0 0 1-10.139 0l3.721-17.938a.695.695 0 0 1 .678-.554h1.338a.695.695 0 0 1 .677.554l3.725 17.938z"
                fill="url(#u)"
                fillRule="nonzero"
            />
            <path
                d="M59.823 256.59l-.426 1.982a16.715 16.715 0 0 0 10.138 0l-.4-1.922a20.244 20.244 0 0 1-9.312-.06zM62.67 242.863l-.478 2.305h4.578l-.478-2.305z"
                fill="#F4F5F7"
                fillRule="nonzero"
            />
            <path
                d="M212.08 260.856c0-.993-3.111-1.798-6.947-1.798s-6.947.805-6.947 1.798v1.436c0 .993 3.111 1.799 6.947 1.799s6.947-.806 6.947-1.799v-1.436z"
                fill="url(#v)"
                fillRule="nonzero"
            />
            <path
                d="M210.405 260.472a16.715 16.715 0 0 1-10.139 0l3.72-17.937a.695.695 0 0 1 .678-.554h1.338a.695.695 0 0 1 .678.554l3.725 17.937z"
                fill="url(#w)"
                fillRule="nonzero"
            />
            <path
                d="M200.68 258.49l-.427 1.982a16.715 16.715 0 0 0 10.14 0l-.402-1.922a20.244 20.244 0 0 1-9.312-.06zM203.526 244.763l-.477 2.306h4.577l-.477-2.306z"
                fill="#F4F5F7"
                fillRule="nonzero"
            />
            <path
                d="M129.328 83.987a5.268 5.268 0 0 0 1.833-10.228 2.715 2.715 0 0 1-1.833-2.519v-1.125M129.328 83.987a5.268 5.268 0 0 1-5.267-5.267"
                stroke="#C1C7D0"
                strokeWidth="4.4"
            />
            <path d="M130.624 81.353l55.297 69.506" stroke="#F4F5F7" strokeWidth="4.55" strokeLinecap="round" />
            <rect
                fill="#2684FF"
                fillRule="nonzero"
                transform="rotate(-84.01 173.263 219.386)"
                x="172.732"
                y="217.696"
                width="1.061"
                height="3.38"
                rx=".531"
            />
            <rect
                fill="#FFE380"
                fillRule="nonzero"
                transform="rotate(33.71 136.54 230.882)"
                x="136.009"
                y="228.804"
                width="1.061"
                height="4.155"
                rx=".531"
            />
            <rect
                fill="#FFE380"
                fillRule="nonzero"
                transform="rotate(33.71 181.542 220.409)"
                x="181.011"
                y="218.975"
                width="1.061"
                height="2.868"
                rx=".531"
            />
            <rect
                fill="#FFC400"
                fillRule="nonzero"
                transform="rotate(-21.02 103.327 184.652)"
                x="102.796"
                y="183.235"
                width="1.061"
                height="2.834"
                rx=".531"
            />
            <rect
                fill="#F4F5F7"
                fillRule="nonzero"
                transform="rotate(14.51 136.955 215.979)"
                x="136.424"
                y="214.647"
                width="1.061"
                height="2.664"
                rx=".531"
            />
            <rect
                fill="#0065FF"
                fillRule="nonzero"
                transform="rotate(-45 128.377 227.274)"
                x="127.847"
                y="225.196"
                width="1.061"
                height="4.155"
                rx=".531"
            />
            <rect
                fill="#FF5630"
                fillRule="nonzero"
                transform="rotate(42.52 91.735 179.85)"
                x="91.204"
                y="177.772"
                width="1.061"
                height="4.155"
                rx=".531"
            />
            <rect
                fill="#FF5630"
                fillRule="nonzero"
                transform="rotate(-30 127.703 189.398)"
                x="127.172"
                y="187.808"
                width="1.061"
                height="3.179"
                rx=".531"
            />
            <rect
                fill="#0052CC"
                fillRule="nonzero"
                transform="rotate(-21.02 88.732 192.752)"
                x="88.201"
                y="190.675"
                width="1.061"
                height="4.155"
                rx=".531"
            />
            <rect
                fill="#FF8F73"
                fillRule="nonzero"
                transform="rotate(20.43 104.114 228.256)"
                x="103.583"
                y="226.178"
                width="1.061"
                height="4.155"
                rx=".531"
            />
            <rect
                fill="#FF8F73"
                fillRule="nonzero"
                transform="rotate(-51.09 168.672 224.583)"
                x="168.141"
                y="222.506"
                width="1.061"
                height="4.155"
                rx=".531"
            />
            <rect
                fill="#F4F5F7"
                fillRule="nonzero"
                transform="rotate(45 67.156 227.3)"
                x="66.626"
                y="225.929"
                width="1.061"
                height="2.74"
                rx=".531"
            />
            <rect
                fill="#F4F5F7"
                fillRule="nonzero"
                transform="rotate(-45 112.02 218.723)"
                x="111.49"
                y="217.353"
                width="1.061"
                height="2.74"
                rx=".531"
            />
            <rect
                fill="#FFE380"
                fillRule="nonzero"
                transform="rotate(45 88.726 219.348)"
                x="88.195"
                y="217.27"
                width="1.061"
                height="4.155"
                rx=".531"
            />
            <rect
                fill="#2684FF"
                fillRule="nonzero"
                transform="rotate(90 70.156 219.877)"
                x="69.625"
                y="217.799"
                width="1.061"
                height="4.155"
                rx=".531"
            />
            <path
                d="M24.203 194.197c.118.332.322.626.592.853.448.379 1.85 1.56 2.289 1.236.209-.158.106-.597 0-.81-.166-.426-.789-.426-1.066-.853-.06-.093-.098-.14-.166-.234-.175-.234-.264-.35-.328-.345-.136 0-.094.354-.273.426-.311.128-.937-.746-1.1-.648-.06.047.022.29.052.375z"
                fill="#D4B696"
                fillRule="nonzero"
            />
            <path
                d="M28.87 195.787c-.222.584-1.403.852-2.247.464a2.13 2.13 0 0 1-1.052-1.227c-.196-.541 0-.673-.094-1.278-.205-1.279-1.279-1.99-1.048-2.238.05-.06.183-.098.545 0a.264.264 0 0 1 .145-.179c.179-.064.426.188.554.303a24.339 24.339 0 0 1 2.131 2.22c.784 1.1 1.176 1.645 1.065 1.935z"
                fill="#D4B696"
                fillRule="nonzero"
            />
            <path
                d="M26.935 192.267c.282.316.505.681.656 1.078.682 1.376 1.338 2.13 1.24 2.208-.098.076-.303-.197-.426-.324-1.074-1.04-3.09-3.333-2.766-3.631.15-.154.852.225 1.296.669z"
                fill="#D4B696"
                fillRule="nonzero"
            />
            <path
                d="M12.36 219.056c.242-.486.46-.873.613-1.138.251.069.66.167 1.172.252.426.072.78.102.959.123 1.035.128 3.009.329 8.336.674a13.4 13.4 0 0 1 1.001 1.193 12.986 12.986 0 0 1 2.11 4.309c2.13 7.484 2.557 9.836 2.557 9.836 1.999 9.7 2.983 14.554 3.371 15.364.64 1.393 2.378 4.867 1.049 8.025a3.755 3.755 0 0 1-.205.426l-.196.12a8.707 8.707 0 0 1-2.131 1.01 4.688 4.688 0 0 1-1.756.123 3.55 3.55 0 0 1-.677-.852 4.53 4.53 0 0 1-.405-2.984c.243-1.598-.58-3.61-6.393-16.574-.23-.516-.605-1.35-1.12-2.459-.853-1.83-1.721-3.595-2.605-5.297.196 2.13.397 4.087.593 5.817.358 3.188.511 4.023.639 5.967.247 3.622-.132 3.03.115 5.83.311 3.55 1.023 5.728-.277 8.042a6.325 6.325 0 0 1-.354.558 2.924 2.924 0 0 1-2.561.75 2.706 2.706 0 0 1-1.526-1.12 4.262 4.262 0 0 1-.754-1.497 4.53 4.53 0 0 1 0-2.13c.473-2.417.136-5.196-.469-10.186-.699-6.231-1.048-9.346-1.428-10.953-.694-2.983-1.807-5.681-1.112-9.244a13.39 13.39 0 0 1 1.453-3.985z"
                fill="#0052CC"
                fillRule="nonzero"
            />
            <path
                d="M24.437 220.177c-.31-.417-.645-.815-1.001-1.193-5.323-.345-7.3-.546-8.336-.673-.18-.022-.52-.052-.96-.124-.51-.085-.92-.183-1.171-.252-.154.265-.375.653-.614 1.138-.413.74-.757 1.516-1.027 2.319 4.582.99 9.324.99 13.906 0-.243-.42-.509-.825-.797-1.215zM33.523 257.707a5.072 5.072 0 0 1-4.262 1.704 66.041 66.041 0 0 0 1.185 4.59c.665 2.285 1.245 3.857 1.407 6.286.034.525.042.955.042 1.236h2.242l.375-.426.592.396h5.694a.524.524 0 0 0 .499-.686l-2.272-.716a6.393 6.393 0 0 1-4.406-5.25c-.218-1.641-.47-3.457-.687-4.756-.13-.807-.267-1.6-.409-2.378zM14.874 257.26l3.908.2a170.787 170.787 0 0 0-.703 4.606c-.188 1.343-.312 2.344.26 2.762.319.188.702.232 1.056.124a.482.482 0 0 1 .324.771l-1.64 2.13a7.168 7.168 0 0 1-1.023 1.365c-.215.159-.468.26-.733.294-.34.071-.695.026-1.006-.128a1.355 1.355 0 0 1-.541-.588 59.63 59.63 0 0 0 .153-3.734c0-1.704-.047-2.612-.06-5.14-.004-1.159 0-2.083.005-2.663z"
                fill="#091E42"
                fillRule="nonzero"
            />
            <path
                d="M23.376 202.03c-3.162.337-5.707-.153-8.583-.711a22.31 22.31 0 0 1-3.776-1.015 21.156 21.156 0 0 1-3.772-1.883 18.177 18.177 0 0 0 5.574-1.888 2.468 2.468 0 0 1-.144-.452 2.719 2.719 0 0 1 .162-1.594 23.5 23.5 0 0 0-2.818.426c-.994.205-1.973.481-2.927.827a19.374 19.374 0 0 0-3.474 1.705.92.92 0 0 0-.315 1.24c.309.536.65 1.053 1.023 1.547 1.112 1.475 2.288 2.39 4.64 4.223.694.552 1.436 1.04 2.217 1.458.426.234.822.426 1.082.516a19.932 19.932 0 0 1 1.032 4.777 19.992 19.992 0 0 1-.772 7.5 11.008 11.008 0 0 0 4.318 1.77c2.674.43 5.415-.071 7.765-1.42-1.454-1.645-1.705-2.919-1.59-3.797.268-1.977 2.058-2.766 2.327-4.982a5.25 5.25 0 0 0-.746-3.205c.269-.064.567-.14.89-.23l.35-.098c2.15-.63 4.19-1.587 6.048-2.838 2.8-1.867 4.41-2.937 4.343-4.373 0-.366-.154-1.006-1.526-2.246a15.108 15.108 0 0 0-6.725-3.43l-1.351 2.386 5.259 2.898a20.964 20.964 0 0 1-8.511 2.89z"
                fill="#0049B0"
                fillRule="nonzero"
            />
            <path
                d="M19.94 193.856c-.135.086-.277.16-.425.222a3.115 3.115 0 0 0-1.091.746c-.512.618.14 1.364-.064 2.753a4.262 4.262 0 0 0 .047 1.594c.09.426.064 1.308-.371 3.354l.545-.324 1.565-1.15c1.022-1.186 1.278-1.39 1.108-1.987-.192-.716-.533-1.964-.503-2.024.298-.503.8-.725.268-1.095a10.102 10.102 0 0 0-.61-.401c-.23-.12-.477-.503-.468-1.688z"
                fill="#D4B696"
                fillRule="nonzero"
            />
            <path
                d="M18.475 194.764a18.002 18.002 0 0 1 1.018 7.45v.247a5.28 5.28 0 0 1-6.627 4.662l-.324-.098h-.055a3.435 3.435 0 0 1-1.9-4.803 13.02 13.02 0 0 0 1.141-3.269c.572-2.808-.085-4.496 1.313-5.923 1.061-1.087 2.715-1.415 3.265-1.526a3.341 3.341 0 0 1 1.892.034c.483.187.92.478 1.278.852.37.388.652.85.827 1.356a5.736 5.736 0 0 0-1.828 1.018z"
                fill="#091E42"
                fillRule="nonzero"
            />
            <rect fill="#091E42" fillRule="nonzero" x="255.857" y="218.281" width="4.343" height="5.92" rx="1.72" />
            <path
                d="M254.468 196.571c-.043.196-.235 3.69-2.17 4.518-1.453.618-3.435-1.168-4.688-2.217a12.04 12.04 0 0 0 .022-6.98l5.868 1.449a13.092 13.092 0 0 0-.08 1.798c0 .767.093 1.057.315 1.24.21.157.473.226.733.192z"
                fill="url(#x)"
                fillRule="nonzero"
            />
            <path
                d="M275.687 200.594l1.739-3.004a.392.392 0 0 1 .703-.111.511.511 0 0 1 .494-.14.524.524 0 0 1 .367.536.473.473 0 0 1 .375.039c.235.251.25.637.038.907a.614.614 0 0 1 .333.26c.088.15.11.332.06.499-.38 1.206-.567 1.977-.567 1.977a5.758 5.758 0 0 1-2.413 2.455.852.852 0 0 1-1.184-.959l.055-2.459z"
                fill="#C1C7D0"
                fillRule="nonzero"
            />
            <path
                d="M265.237 211.065a3.614 3.614 0 0 1-1.509.116c-1.278-.18-2.067-1.049-2.846-1.859a71.321 71.321 0 0 0-3.78-3.648l.349-8.523a195.546 195.546 0 0 1 8.651 8.865l-.865 5.05z"
                fill="#0049B0"
                fillRule="nonzero"
            />
            <path
                d="M262.382 202.222c.025-.025.042-.055.068-.08a203.528 203.528 0 0 0-2.34-2.379l-1.278 1.279 1.184 1.184c.655.651 1.713.65 2.366-.004z"
                fill="#253858"
                fillRule="nonzero"
            />
            <path
                d="M251.608 271.476l-.627-1.065a12.875 12.875 0 0 1-5.63-3.78l-2.855.426a9.184 9.184 0 0 0-.665 3.66l2.097.137a.767.767 0 0 1 1.475.23 16.68 16.68 0 0 0 6.2.384l.005.008zM264.393 270.624l-.626-1.065a12.875 12.875 0 0 1-5.63-3.78l-2.855.426a9.184 9.184 0 0 0-.665 3.66l2.097.137a.767.767 0 0 1 1.474.23 16.68 16.68 0 0 0 6.201.384l.004.008z"
                fill="#091E42"
                fillRule="nonzero"
            />
            <path
                d="M257.6 216.798c.656 4.99 1.18 10.266 1.509 15.802a223.744 223.744 0 0 1-.512 33.455 5.8 5.8 0 0 1-4.236.158 2103.306 2103.306 0 0 1-.281-21.995c-.267-1.73-.51-3.516-.729-5.357-.362-3.111-.61-6.094-.763-8.95a516.937 516.937 0 0 0-2.706 14.98 491.292 491.292 0 0 0-3.162 22.209c-1.509.306-3.525.464-4.944 0a140.15 140.15 0 0 1 1.64-22.9 232.783 232.783 0 0 1 1.3-26.384l12.884-1.018z"
                fill="#0052CC"
                fillRule="nonzero"
            />
            <path
                d="M243.408 267.385l4.143-49.096-.831-.068-4.139 49.079c.274.043.55.071.827.085z"
                fill="#DFE1E5"
                fillRule="nonzero"
                className="cls-1"
            />
            <path
                d="M256.56 218.08a15.64 15.64 0 0 1-8.95.853l.52-23.265 3.512 2.301 1.87-1.914c.157.49.31.982.457 1.48a65.542 65.542 0 0 1 2.591 20.545z"
                fill="#0049B0"
                fillRule="nonzero"
            />
            <path
                fill="#DFE1E5"
                fillRule="nonzero"
                className="cls-1"
                d="M251.118 197.598l.29 9.376.852-.025-.29-9.312-.298.306z"
            />
            <path fill="#091E42" fillRule="nonzero" d="M244.738 218.681h14.192v3.623h-14.192z" />
            <path
                d="M257.813 208.402c.654-3.718.654-7.521 0-11.239a9.76 9.76 0 0 0-4.287-1.12c.365 1.303.483 2.663.35 4.01a11.038 11.038 0 0 1-2.106 5.408 14.622 14.622 0 0 1-3.107-5.71 14.418 14.418 0 0 1-.524-4.096 42.191 42.191 0 0 0-3.077 1.751c-.284.18-.568.358-.853.537a4.564 4.564 0 0 0-1.461 1.428c-.78 1.24-.704 2.604-.341 5.165.405 2.89.682 3.21 1.142 6.073.324 1.75.496 3.523.511 5.302a22.903 22.903 0 0 1-.392 3.917c1.097.476 2.26.782 3.448.907a11.895 11.895 0 0 0 5.182-.626c1.9.78 4.061.574 5.78-.55-.077-.784-.184-1.93-.303-3.32-.132-1.513-.21-2.271-.226-2.817a30.101 30.101 0 0 1 .264-5.02z"
                fill="#FFC400"
                fillRule="nonzero"
            />
            <path
                d="M251.719 204.762l.524 16.783"
                stroke="#FFE380"
                strokeWidth="1.95"
                fill="#DFE1E5"
                fillRule="nonzero"
                className="cls-1"
            />
            <path
                d="M252.14 204.916c-.131.204-.264.392-.37.54-.14-.161-.298-.353-.46-.557l.477 15.376c.187-.055.366-.115.52-.166l.311.115-.477-15.308z"
                fill="#FFE380"
                fillRule="nonzero"
                className="cls-1"
            />
            <path
                d="M275.201 202.26l-.042-.639a4.006 4.006 0 0 1 .234-1.64l.852-2.272a.908.908 0 0 1 .61 1.074l-.218.92.763 2.928-1.278.772a1.279 1.279 0 0 1-.92-1.142z"
                fill="#C1C7D0"
                fillRule="nonzero"
            />
            <path
                d="M235.55 212.553c.41.122.85.086 1.235-.102 2.084-.73 3.516-2.042 4.65-3.112.933-.882 1.982-1.909 3.111-3.072.198-.658.34-1.33.426-2.012.229-2.07-.04-4.166-.784-6.111-.425.09-.806.325-1.078.665-.997 1.04-1.752 1.828-2.131 2.203-.737.754-4.19 4.262-5.967 6.883l-.063.093a3.93 3.93 0 0 0-.235.427c-.145.32-.575 3.567.835 4.138z"
                fill="#0049B0"
                fillRule="nonzero"
            />
            <path
                d="M244.393 198.787l-.47-.426-7.027 7.71.614.562 6.95-7.607-.067-.239z"
                fill="#DFE1E5"
                fillRule="nonzero"
                className="cls-1"
            />
            <path
                d="M242.867 202.806l-1.845-1.845-.047.05c-.316.325-1.13 1.152-2.093 2.2a1.666 1.666 0 0 0 2.804.784l1.181-1.189z"
                fill="#253858"
                fillRule="nonzero"
            />
            <path
                d="M251.774 194.85c2.557.349 2.817.425 3.107.161.205-.174.362-.724.67-1.815.153-.55.268-1.015.344-1.343.18.051.674.18.819-.021.144-.2 0-.37-.158-.729a9.828 9.828 0 0 1-.426-1.376c0-.091.008-.186.025-.286a4.432 4.432 0 0 0-1.662-3.665c-1.214-.997-3.341-1.607-5.16-.614a4.581 4.581 0 0 0-2.294 3.555 9.41 9.41 0 0 0 .516 2.983c.038.106.064.183.064.192.11.353.677.694.677.694.495.299.597.184.853.38.49.35.328.852.686 1.278.294.388.656.43 1.94.605z"
                fill="#8C715D"
                fillRule="nonzero"
            />
            <path
                d="M249.004 192.377c.678-.328.38-1.922.903-2.066.23-.064.512.183.746.456h.793a7.01 7.01 0 0 1 .303-1.667c.29-.929.524-1.705 1.07-1.862.425-.128.621.192 2.258.903.334.156.68.284 1.036.384a4.262 4.262 0 0 0-.15-.644 4.974 4.974 0 0 0-1.453-2.1c-1.214-.998-3.341-1.607-5.16-.614a4.581 4.581 0 0 0-2.294 3.554 9.41 9.41 0 0 0 .516 2.983c.038.107.064.183.064.192.085.098.852.737 1.368.481z"
                fill="#091E42"
                fillRule="nonzero"
            />
            <path
                d="M238.162 211.027c1.087-2.16-1.372-4.586-4.343-12.027a58.252 58.252 0 0 1-.801-2.105 3.861 3.861 0 0 0-2.489.946c.205 2.076.452 3.797.656 5.055.563 3.439 1.126 5.45 2.238 7.432 1.112 1.982 1.828 2.246 2.284 2.289.916.085 1.982-.644 2.455-1.59z"
                fill="#0049B0"
                fillRule="nonzero"
            />
            <path
                d="M230.861 197.594l1.057 8.877a15.943 15.943 0 0 0 1.236 3.329l-1.5-12.628c-.28.11-.546.251-.793.422z"
                fill="#DFE1E5"
                fillRule="nonzero"
                className="cls-1"
            />
            <path
                d="M264.58 206.058c.968-.92 1.872-1.134 4.292-1.91 1.33-.426 3.41-1.099 5.967-2.002l2.212 2.59c-2.694 2.068-7.599 5.515-11.822 6.33-1.057.204-1.884.208-2.289-.26-.771-.9.132-3.312 1.64-4.748z"
                fill="#0049B0"
                fillRule="nonzero"
            />
            <path
                d="M256.74 187.609l-9.688-.09a.222.222 0 0 1-.217-.239l.025-.366 9.726-.563.477.635a.4.4 0 0 1-.324.623z"
                fill="#253858"
                fillRule="nonzero"
            />
            <path
                d="M256.586 186.334l-9.726.563-.477-1.598a.426.426 0 0 1 .358-.546l10.497-1.24a.243.243 0 0 1 .26.328l-.912 2.493z"
                fill="#091E42"
                fillRule="nonzero"
            />
            <path d="M257.349 184.25a.908.908 0 1 0-.623 1.705l.623-1.705z" fill="#FFAB00" fillRule="nonzero" />
            <circle fill="#FFAB00" fillRule="nonzero" cx="255.857" cy="201.357" r="1.266" />
            <rect fill="#091E42" fillRule="nonzero" x="243.097" y="219.653" width="4.343" height="5.92" rx="1.72" />
            <rect fill="#091E42" fillRule="nonzero" x="247.376" y="219.968" width="1.573" height="5.263" rx=".786" />
            <ellipse fill="#0049B0" fillRule="nonzero" cx="244.231" cy="203.484" rx="1.607" ry="5.549" />
            <path fill="#F4F5F7" fillRule="nonzero" d="M254.936 203.313h2.37v1h-2.37z" />
            <path
                d="M251.275 199.452l.376-1.5-3.508-2.792a2.25 2.25 0 0 0-.362 1.671l.038.217 3.456 2.404zM252.03 199.452l-.375-1.5 1.785-2.493.273.426c.14.23.239.482.29.746v.03l-1.973 2.791z"
                fill="#0052CC"
                fillRule="nonzero"
            />
            <path
                d="M149.78 55.459a5.078 5.078 0 1 1 9.922 2.169 14.294 14.294 0 0 1-9.921-2.17z"
                fill="#FFAB00"
                fillRule="nonzero"
            />
            <path
                d="M20.205 193.174l-7.718-.085a.175.175 0 0 1-.175-.187l.022-.294 7.748-.427.379.508a.32.32 0 0 1-.256.485z"
                fill="#253858"
                fillRule="nonzero"
            />
            <path
                d="M20.086 192.16l-7.748.426-.38-1.278a.34.34 0 0 1 .286-.426l8.366-.985a.196.196 0 0 1 .205.26l-.73 2.003z"
                fill="#091E42"
                fillRule="nonzero"
            />
            <path d="M22.157 220.113l11.162 38.028" stroke="#DFE1E5" strokeWidth="2.04" className="cls-1" />
            <path
                d="M24.62 206.252l-.765-3.458 1.723-.381a1.769 1.769 0 0 1 2.109 1.344 1.769 1.769 0 0 1-1.344 2.113l-1.727.383.004-.001z"
                fill="#172B4D"
                fillRule="nonzero"
            />
            <path fill="#0049B0" fillRule="nonzero" d="M21.854 193.076h1.155v1h-1.155z" />
            <path d="M22.737 192.024h.852v.643h-1.492c0-.353.286-.64.64-.643z" fill="#42526E" fillRule="nonzero" />
            <path fill="#6C798F" fillRule="nonzero" d="M23.572 192.024h1v1h-1z" />
            <rect fill="#091E42" fillRule="nonzero" x="21.309" y="218.311" width="5.344" height="5.344" rx="2.672" />
            <rect fill="#091E42" fillRule="nonzero" x="19.072" y="218.72" width="1.7" height="4.76" rx=".85" />
        </g>
    </svg>
);

export default WhoopsError;
